import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export interface FAQ {
  q: string;
  a: string;
}
interface FAQSectionProps {
  faqs: FAQ[];
  title?: string;
}
export function FAQSection({
  faqs,
  title = 'Întrebări Frecvente'
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  if (!faqs || faqs.length === 0) return null;
  return <section className="bg-brand-ivory section-padding" data-id="element-107">
      <div className="container-custom" data-id="element-108">
        <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-109">
          {title}
        </h2>
        <div className="max-w-3xl mx-auto space-y-4" data-id="element-110">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-[16px] shadow-sm border border-gray-100 overflow-hidden" data-id="element-111">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-112">
                <h3 className="font-montserrat font-bold text-[16px] text-brand-navy pr-8" data-id="element-113">
                  {faq.q}
                </h3>
                <ChevronDownIcon className={`text-brand-navy transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-114" />
              </button>
              <AnimatePresence data-id="element-115">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-116">
                    <div className="px-6 pb-6 pt-2 border-t border-gray-50" data-id="element-117">
                      <p className="font-source text-[15px] text-brand-text" data-id="element-118">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}